module.exports = __webpack_public_path__ + "static/media/login_bg_1_1920x1080.88b4f17d.jpg";